import { useEffect, useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

export function useWindowSize() {
  const [size, setSize] = useState({ width: 0, height: 0 });

  const update = () => {
    if (typeof window === 'undefined') return;
    setSize({ width: window.innerWidth, height: window.innerHeight });
  };

  useIsomorphicLayoutEffect(() => {
    update();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return size;
}
